import { getColumnsMetadata as getHotelColumnsMetadata } from './hotel';

export function getName({
  CampaignId, // actually sub account id
}) {
  if (CampaignId) {
    return 'HotelGroupGrid';
  }
  return 'AllSubAccountHotelGroupGrid';
}

export function getColumnsMetadata() {
  return getHotelColumnsMetadata();
}

export function getPage() {
  return 'HotelCenter';
}

export function getRoute() {
  return 'overview/grid-chooser-item-hotel-group';
}
